import React, { useEffect, useState } from "react";
import { authAxios } from "../../utils/axiosWrapper";
import { apiEndPoint, BOOKING_ENDPOINTS } from "../../contants/Endpoints";
import ButtonFilled from "../../components/ButtonFilled";
import ButtonOutlined from "../../components/ButtonOutlined";
import Loading from "../../components/Loader/Loading";
import ReactModal from "react-modal";
import { SvgCross } from "../../components/common/AllSVGImport";
import SendEmailView from "./comp/sendMailView";
import PaginationComponent from "../../components/common/Pagination";
import { integerDateToValidDate } from "../../utils/DateFormatTranferToSixDigit";
import { data } from "autoprefixer";
import { toastMessage } from "../../utils/toast";

const AdminNonExpressBookings = () => {
    const [bookingOverlay, setBookingOverlay] = useState(false);
    const [openSubmitModal, setOpenSubmitModal] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const [selectedBooking, setSelctedBooking] = useState(null);

    const [pageSize, setPageSize] = useState(5);
    const [totalElements, setTotalElements] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const [status, setStatus] = useState("");
    const [searchValue, setSearchValue] = useState("");

    const [loading, setLoading] = useState(true);

    // const [newBookings, setNewBookings] = useState(initialNew);
    // const [inProgBookings, setInProgBookings] = useState(initialProg);
    // const [bookedBookings, setBookedBookings] = useState(initialBooked);
    // const [cancelledBookings, setCancelledBookings] = useState(initialCancel);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [currentView, setCurrentView] = useState("default");

    const statusToUrlMap = {
        INIT: "",
        BOOKING_IN_PROGRESS: "ADMIN_SEND_EMAIL_HOTEL_LIST",
        HOTEL_LIST_SENT: "ADMIN_DIRECT_BOOKING_MERGE",
    };

    const statusToButtonTextMap = {
        BOOKING_IN_PROGRESS: "Send hotel list",
        HOTEL_LIST_SENT: "Send payment link",
    };

    const [directBookings, setDirectBookings] = useState([]);

    const onModalOpen = async (itemIndex) => {
        if (directBookings[itemIndex].status === "INIT") {
            if (
                await changeStatus(
                    directBookings[itemIndex].id,
                    "BOOKING_IN_PROGRESS",
                    "",
                    ""
                )
            ) {
                getBookings();
                setSelctedBooking({
                    ...directBookings[itemIndex],
                    status: "BOOKING_IN_PROGRESS",
                });
                setBookingOverlay(true);
            }
        } else {
            setSelctedBooking({
                ...directBookings[itemIndex],
            });
            setBookingOverlay(true);
        }
    };

    useEffect(() => {
        getBookings();
    }, [currentPage, status, startDate, endDate, pageSize]);

    const getBookings = () => {
        setLoading(true);
        authAxios
            .get(
                `${apiEndPoint.ADMIN_GET_NON_EXPRESS_BOOKINGS}?requestId=123&invoiceStatus=${status}&pageSize=${pageSize}&pageNo=${currentPage}`
            )
            .then((res) => {
                setDirectBookings(() => [...res.data.data]);
                setTotalElements(res.data.totalElements);
                setLoading(false);
            })
            .catch((err) => {
                setDirectBookings([]);
                setLoading(false);
                console.log(err);
            });
    };

    const onConfirm = async () => {
        setLoading(true);
        authAxios
            .patch(`${apiEndPoint.ADMIN_BOOKING_CONFIRM}`, {
                cancelUrl: `${process.env.REACT_APP_FRONT_END}payment-status?status=failed&uuid=${selectedBooking.invoiceUuId}`,
                failUrl: `${process.env.REACT_APP_FRONT_END}payment-status?status=failed&uuid=${selectedBooking.invoiceUuId}`,
                invoiceId: selectedBooking.invoiceUuId,
                paymentChannel: "bkash.old",
                requestId: "123",
                successUrl: `${process.env.REACT_APP_FRONT_END}payment-status?status=success&uuid=${selectedBooking.invoiceUuId}`,
            })
            .then((res) => {
                const formData = {
                    // to:selectedBooking.personEmail,
                    paymentUrl: res.data.data,
                    invoiceUuid: selectedBooking.invoiceUuId,
                    requestId: "string",
                    name: selectedBooking.personName,
                };
                authAxios
                    .post(
                        `${apiEndPoint.ADMIN_SEND_EMAIL_PAYMENT_LINK}?requestId=email`,
                        formData
                    )
                    .then((res2) => {
                        setLoading(false);
                        toastMessage("Operation Successful!");
                        getBookings();
                        setBookingOverlay(false);
                    });
            })
            .catch((err) => {});
    };

    const onCancel = async () => {
        if (await changeStatus(selectedBooking.invoiceUuId, "CANCELED")) {
            getBookings();
            setBookingOverlay(false);
        }
    };

    const changeStatus = async (
        uuid,
        status,
        rejectionDetails = "string",
        rejectionReason = "string"
    ) => {
        setLoading(true);
        await authAxios.patch(
            `${apiEndPoint.ADMIN_BOOKING_INVOICE_STATUS}${uuid}`,
            {
                invoiceStatus: status,
                requestId: "string",
                rejectionDetails,
                rejectionReason,
            },
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("jwt")}`,
                },
            }
        );
        setLoading(false);
        return true;
    };

    const assignNewStatus = async (uuid, status) => {
        if (await changeStatus(uuid, status)) {
            // alert("changing");
            getBookings();
            setSelctedBooking({ ...selectedBooking, status: status });
        }
    };

    const statusData = [
        { value: "", name: "All" },
        { value: "INIT", name: "New" },
        { value: "BOOKING_IN_PROGRESS", name: "In Progress" },
        // { value: "HOTEL_LIST_SENT", name: "Hotel List Sent" },
        // { value: "PAYMENT_LINK_SENT", name: "Payment Link Sent" },
        // { value: "PAYMENT_SUCCESSFUL", name: "Payment successfull" },
        { value: "BOOKED", name: "Confirmed" },
        { value: "CANCELED", name: "Cancelled" },
    ];
    // const

    return (
        <div className="container mx-auto">
            <div className="flex gap-10 justify-between items-center">
                <div className="text-2xl">
                    Non Express Bookings ({totalElements}){" "}
                </div>
            </div>
            <div className="flex justify-between items-center">
                <div className="flex gap-4 items-center my-10">
                    <div> Filter : </div>
                    {statusData.map((st, index) => (
                        <button
                            key={st.value}
                            onClick={() => {
                                setStatus(st.value);
                            }}
                            className={`rounded-lg transition duration-400 active:scale-90 py-2 px-6 shadow-md hover:bg-btn-secondary hover:text-txt-secondary ${
                                status === st.value &&
                                "bg-btn-primary text-txt-secondary"
                            } `}
                        >
                            {st.name}
                        </button>
                    ))}
                </div>

                <div>
                    {/* <input
                        className="px-4 w-full outline-none rounded-lg shadow-md bg-[transparent] focus:shadow-lg h-[50px]"
                        placeholder="Search..."
                        value={searchValue}
                        onChange={(e) => setSearchValue(e.target.value)}
                    /> */}
                </div>
            </div>
            <div className="pb-20">
                <div className="h-[550px] overflow-y-auto w-full">
                    {!loading ? (
                        <table
                            id="students"
                            className="min-w-full leading-normal"
                        >
                            <thead>
                                <tr className="sticky h-[78px] px-5 py-3 border-b-2 border-gray-200 bg-btn-primary text-left text-xl font-normal text-bg-white tracking-wider">
                                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xl font-normal text-gray-700 tracking-wider"></th>
                                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xl font-normal text-gray-700 tracking-wider">
                                        ID
                                    </th>
                                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xl font-normal text-gray-700 tracking-wider">
                                        Date
                                    </th>
                                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xl font-normal text-gray-700 tracking-wider">
                                        Name
                                    </th>
                                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xl font-normal text-gray-700 tracking-wider">
                                        Email
                                    </th>
                                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xl font-normal text-gray-700 tracking-wider">
                                        Phone
                                    </th>
                                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xl font-normal text-gray-700 tracking-wider">
                                        Status
                                    </th>
                                    <th className="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xl font-normal text-gray-700 tracking-wider">
                                        Action
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="">
                                {directBookings &&
                                    !loading &&
                                    directBookings.map((booking, index) => {
                                        const {
                                            personName,
                                            personEmail,
                                            personNumber,
                                            invoiceUuId,
                                            invoiceStatus,
                                            createdAt,
                                        } = booking;
                                        return (
                                            <tr
                                                key={invoiceUuId || index}
                                                className="border-b"
                                            >
                                                <td className="h-[80px] px-5 py-5 bg-white text-sm">
                                                    {currentPage * pageSize +
                                                        (index + 1)}
                                                    .
                                                </td>
                                                <td className="h-[80px] px-5 py-5 bg-white text-sm">
                                                    {invoiceUuId}
                                                </td>
                                                <td className="h-[80px] px-5 py-5 bg-white text-sm text-left">
                                                    {new Date(
                                                        createdAt
                                                    ).toDateString()}
                                                </td>
                                                <td className="h-[80px] px-5 py-5 bg-white text-sm text-left">
                                                    {personName
                                                        ? personName
                                                        : "N/A"}
                                                </td>
                                                <td className="h-[80px] px-5 py-5 bg-white text-sm text-left">
                                                    {personEmail
                                                        ? personEmail
                                                        : "N/A"}
                                                </td>
                                                <td className="h-[80px] px-5 py-5 bg-white text-sm text-left">
                                                    {personNumber
                                                        ? personNumber
                                                        : "N/A"}
                                                </td>
                                                <td className="h-[80px] px-5 py-5 bg-white text-sm text-left">
                                                    {Object.values(
                                                        statusData
                                                    ).map(
                                                        (item) =>
                                                            item.value ===
                                                                invoiceStatus &&
                                                            item.name
                                                    )}
                                                </td>
                                                <td className="h-[80px] px-5 py-5 bg-white text-sm">
                                                    <ButtonOutlined
                                                        title={"See details"}
                                                        w="100%"
                                                        buttonOutlinedHandle={() =>
                                                            onModalOpen(index)
                                                        }
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })}
                                {directBookings.length === 0 && !loading && (
                                    <tr className="border">
                                        <td className="h-[80px] px-5 py-5 bg-white text-sm text-left">
                                            No data
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    ) : (
                        <div className="w-full flex justify-center items-center">
                            <div>
                                <Loading />
                            </div>
                        </div>
                    )}
                </div>
                <PaginationComponent
                    totalElements={totalElements}
                    currentPage={currentPage}
                    dataSize={directBookings.length}
                    pageSize={pageSize}
                    setCurrentPage={setCurrentPage}
                    setPageSize={setPageSize}
                    showCount={true}
                />
                {/* {loading && (

                )} */}
            </div>
            {bookingOverlay && (
                <ReactModal
                    isOpen={bookingOverlay}
                    onRequestClose={() => {
                        setCurrentView("default");
                        setBookingOverlay(false);
                        setSelctedBooking(null);
                    }}
                    ariaHideApp={false}
                >
                    <div className="min-h-[200px] mx-auto min-w-[1200px] py-8 break-words relative">
                        <div
                            onClick={() => {
                                setCurrentView("default");
                                setBookingOverlay(false);
                                setSelctedBooking(null);
                            }}
                            className="cursor-pointer absolute right-8 top-4"
                        >
                            <SvgCross />
                        </div>
                        {currentView === "default" && (
                            <React.Fragment>
                                <div className="mb-12">
                                    <div className="text-center text-2xl">
                                        Booking{" "}
                                        <span className="font-bold">
                                            {selectedBooking.invoiceUuId}
                                        </span>
                                    </div>
                                    <div className="text-center">
                                        Status:
                                        <select
                                            className="font-semibold bg-[transparent] px-4 cursor-pointer"
                                            onChange={(e) =>
                                                assignNewStatus(
                                                    selectedBooking.invoiceUuId,
                                                    e.target.value
                                                )
                                            }
                                            value={
                                                selectedBooking.invoiceStatus
                                            }
                                        >
                                            {statusData.map((st, index) => (
                                                <React.Fragment>
                                                    <option value={st.value}>
                                                        {" "}
                                                        {st.name}{" "}
                                                    </option>
                                                </React.Fragment>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="text-center my-2">
                                        Booking Date :{" "}
                                        {new Date(
                                            selectedBooking.createdAt
                                        ).toDateString()}
                                    </div>
                                </div>
                                <div className="">
                                    {loading && (
                                        <div className="flex justify-center h-[300px] items-center">
                                            <Loading />
                                        </div>
                                    )}
                                    {!loading && (
                                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                                            <div className="col-span-1">
                                                <div className="text-bg-semiblack mb-2 capitalize">
                                                    Name:
                                                </div>
                                                <div className="h-[49px]">
                                                    <input
                                                        name="name"
                                                        className=" w-full bg-[transparent] pl-6 outline-0 outline-none focus:outline-none border-[#2a220e73] border h-full rounded-lg placeholder:text-bg-semiblack "
                                                        value={
                                                            selectedBooking.personName
                                                        }
                                                        autoComplete={"off"}
                                                    />
                                                </div>
                                                <div className="text-bg-semiblack mb-2 capitalize mt-4">
                                                    phone number:
                                                </div>
                                                <div className="h-[49px]">
                                                    <input
                                                        name="email"
                                                        value={
                                                            selectedBooking.personNumber
                                                        }
                                                        className=" w-full bg-[transparent] pl-6 outline-0 outline-none focus:outline-none border-[#2a220e73] border h-full rounded-lg placeholder:text-bg-semiblack "
                                                        placeholder="example@email.com"
                                                        autoComplete={"off"}
                                                    />
                                                </div>
                                                <div className="text-bg-semiblack mb-2 capitalize mt-4">
                                                    email:
                                                </div>
                                                <div className="h-[49px]">
                                                    <input
                                                        name="email"
                                                        value={
                                                            selectedBooking.personEmail
                                                        }
                                                        className=" w-full bg-[transparent] pl-6 outline-0 outline-none focus:outline-none border-[#2a220e73] border h-full rounded-lg placeholder:text-bg-semiblack "
                                                        placeholder="example@email.com"
                                                        autoComplete={"off"}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-span-1">
                                                <div className="text-bg-semiblack mb-2">
                                                    Amount
                                                </div>
                                                <div className="text-txt-primary my-2 capitalize h-[49px]">
                                                    <input
                                                        value={` ${selectedBooking.totalPayable} per night`}
                                                        className=" w-full bg-[transparent] pl-6 outline-0 outline-none focus:outline-none border-[#2a220e73] border h-full rounded-lg placeholder:text-bg-semiblack "
                                                    />
                                                </div>

                                                <div className="mt-4 grid  grid-cols-1 ">
                                                    <div className="col-span-1 relative">
                                                        <div className="text-bg-semiblack text-base11 sm:text-base16 ">
                                                            Duration
                                                        </div>
                                                    </div>
                                                    <div className="text-txt-primary capitalize my-2 h-[49px]">
                                                        <input
                                                            value={` ${selectedBooking.bookingCategoryData[0].fromDate} per night`}
                                                            className=" w-full bg-[transparent] pl-6 outline-0 outline-none focus:outline-none border-[#2a220e73] border h-full rounded-lg placeholder:text-bg-semiblack "
                                                        />
                                                    </div>
                                                </div>

                                                <div className="hidden lg:grid grid-cols-4 mt-4 justify-between gap-2">
                                                    <div className="col-span-1 ">
                                                        <div className="text-bg-semiblack text-sm text-center mb-4">
                                                            Number of Rooms
                                                        </div>
                                                        <div className="rounded-[70px] shadow-lg h-[50px] flex justify-center items-center  w-full">
                                                            <button className="px-1 w-full h-full">
                                                                -
                                                            </button>
                                                            <input
                                                                value={
                                                                    selectedBooking
                                                                        .bookingCategoryData[0]
                                                                        .noOfRooms
                                                                }
                                                                className="bg-[transparent]  outline-none text-txt-primary text-center w-[50px] h-full"
                                                            />

                                                            <button className="px-1 w-full h-full">
                                                                +
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="hidden sm:block sm:col-span-1"></div>

                                                    <div className="col-span-1 ">
                                                        <div className="text-bg-semiblack text-sm text-center mb-4">
                                                            Number of Adults
                                                        </div>
                                                        <div className="rounded-[70px] shadow-lg h-[50px] flex justify-center items-center  w-full">
                                                            <button className="px-1 w-full h-full">
                                                                -
                                                            </button>
                                                            <input
                                                                value={
                                                                    selectedBooking
                                                                        .bookingCategoryData[0]
                                                                        .onOfExtraAdult
                                                                }
                                                                className="bg-[transparent]  outline-none text-txt-primary text-center w-[50px] h-full"
                                                            />

                                                            <button className="px-1 w-full h-full">
                                                                +
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="col-span-1 ">
                                                        <div className="text-bg-semiblack text-sm text-center mb-4">
                                                            Number of Child
                                                        </div>
                                                        <div className="rounded-[70px] shadow-lg h-[50px] flex justify-center items-center  w-full">
                                                            <button className="px-1 w-full h-full">
                                                                -
                                                            </button>
                                                            <input
                                                                value={
                                                                    selectedBooking
                                                                        .bookingCategoryData[0]
                                                                        .noOfExtraChild
                                                                }
                                                                className="bg-[transparent]  outline-none text-txt-primary text-center w-[50px] h-full"
                                                            />

                                                            <button className="px-1 w-full h-full">
                                                                +
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </React.Fragment>
                        )}

                        <div className="mt-10 flex justify-center gap-4">
                            <div className="w-[300px]">
                                <ButtonOutlined
                                    w={"100%"}
                                    arrow="no"
                                    title={"Cancel"}
                                    buttonOutlinedHandle={() => {
                                        onCancel();
                                    }}
                                />
                            </div>
                            <div className="w-[300px]">
                                <ButtonFilled
                                    w={"100%"}
                                    arrow="no"
                                    title={"Confirm"}
                                    buttonFilledHandle={() => {
                                        onConfirm();
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </ReactModal>
            )}
        </div>
    );
};

export default AdminNonExpressBookings;
